var _rect, _g, _use, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CentOS",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 118,
    fill: "#9ccd2a",
    width: 124,
    height: 124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 118,
    fill: "#932279",
    width: 124,
    height: 124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 270,
    fill: "#efa724",
    width: 124,
    height: 124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 270,
    fill: "#262577",
    width: 124,
    height: 124
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(225 256 256)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 9,
    d: "m236 256-87 88-88-88 88-88zm6-14H118V118H242zm0 28V394H118V270zm14-34-88-87 88-88 88 88zm0 40-88 87 88 88 88-88zm14-34V118H394V242zm0 28H394V394H270zm6-14 87 88 88-88-88-88z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentos);
export default __webpack_public_path__ + "static/media/centos.6850256d74bd61f5e75e1765648bc059.svg";
export { ForwardRef as ReactComponent };